import React, { FC } from 'react';

interface EnrollProps {
  product_id: string;
  can_enroll: boolean;
  call: boolean;
  url: string;
}

const Enroll: FC<EnrollProps> = ({ product_id, can_enroll, call, url }) => {
  const root = document.getElementById('root');
  const domainUrl = root?.getAttribute('data-domain-url');
  return (
    <>
      {call && !can_enroll ? (
        <a
          className='enroll_btn disable'
          href={url || `${domainUrl}/classes/wait-list/${product_id}`}
        >
          WAIT LIST
        </a>
      ) : (
        <button
          className={can_enroll ? 'enroll_btn' : 'enroll_btn disable'}
          onClick={() => {
            const form = document.getElementById(
              `event-${product_id}-form`
            ) as HTMLFormElement;
            form?.submit();
          }}
        >
          Enroll
        </button>
      )}

      <form
        action={`${domainUrl}/cart/add`}
        method='POST'
        id={`event-${product_id}-form`}
        style={{
          display: 'none',
        }}
      >
        <input
          type='hidden'
          name='product_id'
          value={product_id}
          id={product_id}
        />
      </form>
    </>
  );
};

export default Enroll;
